// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8bd8482d","239":"f330222b","455":"57a8e902"}[chunkId] + ".chunk.js";
};